import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function normalizeTableNumber(number: string): string {
  return number.replace(/^0+/, '') || '0';
}

export function sortByNumberField<T extends { number: string }>(items: T[]): T[] {
  return [...items].sort((a, b) => 
    a.number.localeCompare(b.number, undefined, { numeric: true })
  );
}
